import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import the main CSS file for Tailwind directives
import App from './App.jsx'; // Updated import path
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from './components/common/ErrorBoundary.jsx';
// import reportWebVitals from './reportWebVitals'; // You can remove this if not using web vitals

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();